import PropTypes from 'prop-types';
import { destinationPickerDTPageType, fareFinderDTPageType, flightIsm2PageType, flightsIsmDTNewPageType, flightsStaticPageType } from '../utils/Constants';
import FlightRouteDT from '../components/FlightRouteDT';
import FlightRoutePWA from '../components/FlightRoutePWA';
import FareFinderDT from '../components/FareFinderDT';
import FlightDistanceDT from '../components/FlightDistanceDT';
import CityDT from '../components/CityDT';
import CityCountryDT from '../components/CityCountryDT';
import Offers from '../components/offers';
import FlightDistancePWA from '../components/FlightDistancePWA';
import CityPWA from '../components/CityPWA';

export default function Body(props) {
  const { data } = props || {};
  const { pageType, isDeviceMobile } = data || {};
  return (
    <>
      { pageType === 'offerPage' && <Offers data={data} />}
      { flightsIsmDTNewPageType[pageType] && !isDeviceMobile && <FlightRouteDT data={data} /> }
      { flightsIsmDTNewPageType[pageType] && isDeviceMobile && <FlightRoutePWA data={data} /> }
      { fareFinderDTPageType[pageType] && <FareFinderDT data={data} /> }
      { flightIsm2PageType[pageType] && !isDeviceMobile && <FlightDistanceDT data={data} />}
      { flightIsm2PageType[pageType] && isDeviceMobile && <FlightDistancePWA data={data} />}
      { flightsStaticPageType[pageType] && !isDeviceMobile && <CityDT data={data} />}
      { flightsStaticPageType[pageType] && isDeviceMobile && <CityPWA data={data} />}
      { destinationPickerDTPageType[pageType] && !isDeviceMobile && <CityCountryDT data={data} />}
    </>
  );
}

Body.propTypes = {
  // eslint-disable-next-line react/require-default-props, react/forbid-prop-types, react/no-unused-prop-types
  props: PropTypes.object,
};
